import React from 'react';
import _get from 'lodash/get';
import { useStore } from 'react-redux';
import isPlainObject from 'lodash/isPlainObject';
import { validateADGroupAgainstUserRoles } from 'shell/utils/userRoles';

/**
 * determines if the current user has one of provided AD user groups
 * {
 *  isStoreAssociate: 'store_associate',
 *  isBGStylist: {role: 'stylist', brand: 'BG'},
 * }
 * @returns {function(*): function(*=, *): *}
 */
export const withUserGroupMembership = (userGroupsMap = {}) => (Component) => {
  const UserGroupMembership = (props) => {
    const store = useStore();
    const state = store.getState();

    const [assignedADGroup] = _get(state, ['user', 'data', 'groups'], ['']);

    const userGroupMembershipProps = Object.entries(userGroupsMap).reduce((res, [propName, payload]) => {
      let userRole;
      let brand;

      if (isPlainObject(payload)) {
        userRole = payload.role;
        // eslint-disable-next-line prefer-destructuring
        brand = payload.brand;
      } else {
        userRole = payload;
      }

      res[propName] = validateADGroupAgainstUserRoles({
        userRoles: [userRole],
        assignedADGroup,
        brand,
      });

      return res;
    }, {});

    return <Component {...props} {...userGroupMembershipProps} />;
  };

  return UserGroupMembership;
};

export default withUserGroupMembership;
